import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

export const getClientDeliveryAddresses = async (token, clientId, includeDeleted = false) => {
    log("welcome in getClientDeliveryAddresses for client_id=" + clientId)

    if (!token || token === "") {
        return { error: true, message: "No token provided", addresses: [] }
    }

    if (!clientId) {
        log("No client_id provided for getClientDeliveryAddresses")
        return { error: false, addresses: [] }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_client_delivery_addresses_api'
        const params = {
            client_id: clientId,
            include_deleted: includeDeleted
        }

        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getClientDeliveryAddresses")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getClientDeliveryAddresses")
        log(err)
        error.value = err.message
        return { error: true, message: "Error loading delivery addresses", addresses: [] }
    }
}

export const saveClientDeliveryAddress = async (token, addressData) => {
    log("welcome in saveClientDeliveryAddress")
    log(addressData)

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    if (!addressData || !addressData.client_id) {
        log("No client_id in addressData for saveClientDeliveryAddress")
        return { error: true, message: "Client ID is required" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/save_client_delivery_address_api'
        const result = await axios.post(url, addressData, { headers: headers })
        log("result.data din axios saveClientDeliveryAddress")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in saveClientDeliveryAddress")
        log(err)
        error.value = err.message
        return { error: true, message: "Error saving delivery address" }
    }
}

export const deleteClientDeliveryAddress = async (token, addressId, clientId) => {
    log("welcome in deleteClientDeliveryAddress for id=" + addressId)

    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_client_delivery_address_api'
        const result = await axios.post(url, { id: addressId, client_id: clientId }, { headers: headers })
        log("result.data din axios deleteClientDeliveryAddress")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteClientDeliveryAddress")
        log(err)
        error.value = err.message
        return { error: true, message: "Error deleting delivery address" }
    }
}

const useClientDeliveryAddressAPI = () => {
    return { error, getClientDeliveryAddresses, saveClientDeliveryAddress, deleteClientDeliveryAddress }
}

export default useClientDeliveryAddressAPI
